
<template>
  <v-container fill-height fluid grid-list-xl>
    <Loader :loading="loading" />
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="Список" :text="total + ' заказов'">
          <v-btn color="primary" @click="getItems(false)" text>Обновить</v-btn>
          <v-btn color="error" class="ml-2" @click="clearRange" text
            >Сбросить</v-btn
          >

          <div class="mt-2">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск..."
              class="sticky search"
              :loading="loadingSearch"
              single-line
              hide-details
              clearable="true"
            ></v-text-field>
          </div>
          <v-radio-group v-model="countDay">
            <v-layout>
              <v-flex>
                <v-radio
                  @change="setDay"
                  label="Сегодня"
                  color="primary"
                  value="0"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @change="setDay"
                  label="Неделя"
                  color="primary"
                  value="6"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @change="setDay"
                  label="Месяц"
                  color="primary"
                  value="29"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @change="setDay"
                  label="Квартал"
                  color="primary"
                  value="89"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @change="setDay"
                  label="Год"
                  color="primary"
                  value="365"
                ></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>
          <v-radio-group v-model="status">
            <v-layout>
              <v-flex>
                <v-radio
                  @change="setResource"
                  v-bind:checked="status === 1 ? 'checked' : ''"
                  label="Показать новые"
                  color="primary"
                  value="1"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @change="setResource"
                  v-bind:checked="status === 2 ? 'checked' : ''"
                  label="Показать выполненные"
                  color="primary"
                  value="2"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  v-bind:checked="status === 3 ? 'checked' : ''"
                  @change="setResource"
                  label="Показать отмененные"
                  color="primary"
                  value="3"
                ></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>
          <br />
          <v-data-table :headers="headers" :items="PagesList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <!-- <td class="text-xs-left"> <span v-if="item.order_1c_id"> {{item.order_1c_id}} </span><span v-else>Не установлено</span></td> -->
              <td class="text-xs-left">{{ item.id }} / {{ item.ID_1C }}</td>

              <td class="text-xs-right min-width100">
                <span>
                  <v-btn
                    style="width: 100%"
                    color="primary"
                    @click="purchases = item"
                  >
                    <v-icon>mdi-laptop</v-icon>
                  </v-btn>
                </span>
              </td>

              <td class="text-xs-left">
                <!-- <span v-if="item.status===1">Новый</span>
                <span v-else-if="item.status===2">Выполнен</span>
                <span v-else-if="item.status===3">Отменен</span>-->
                <select v-model="item.status" @change="setStatus(item)">
                  <option :value="1">Новый (1)</option>
                  <option :value="2">Выполнен (2)</option>
                  <option :value="3">Отменен (3)</option>
                </select>
              </td>
              <td class="text-xs-left">
                <span v-if="item.type === 1">Заказ</span>
                <span v-else-if="item.type === 2">Бронь</span>
                <span v-else>Не определено</span>
              </td>
              <td class="text-xs-left">
                <span v-if="item.is_discount_query === 1">Да</span>
                <span v-else>Нет</span>
              </td>
              <td class="text-xs-left">{{ item.created_at | dateTime }}</td>
              <td class="text-xs-left">{{ item.distributor.name }}</td>
              <td class="text-xs-left">{{ item.distributor.phone }}</td>
              <td class="text-xs-left">
                {{ item.price_total | numberWithSpaces }} сум
              </td>

              <!-- <td class="text-xs-left">
                <v-btn color="primary" @click="exportToServer(item)">
                  BrandStore
                  <v-icon>mdi-database-import</v-icon>
                </v-btn>
              </td>-->
            </template>
          </v-data-table>
          <div class="horizontal-scroll">
            <v-pagination
              total-visible="20"
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      v-model="dialogShow"
    >
      <v-card>
        <Loader :loading="loading" absolute="true" />
        <v-btn class="close default v-btn--simple" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <purchases
            :serverSend="serverSend"
            :exportToServer="exportToServer"
            :purchases="purchases"
            :getItems="getItems"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Loader from "../../helper/Loader";
import { mapMutations } from "vuex";
import Purchases from "./Purchases";

export default {
  data: () => ({
    page: 1,
    searcher: null,
    token: "",
    shop_id: 1,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      // {
      //   sortable: false,
      //   text: "ID 1C",
      //   value: "dealer.title"
      // },
      {
        sortable: false,
        text: "Номер заказа",
        value: "dealer.title",
      },

      {
        sortable: false,
        text: "Детали",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Статус",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Вид заказа",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Запрос о скидке",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Дата",
        value: "dealer.phone_number",
      },

      {
        sortable: false,
        text: "Дистрибьютор",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Номер телефона",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Общая стоимость",
        value: "dealer.phone_number",
      },

      {
        sortable: false,
        text: "",
        value: "dealer.phone_number",
      },
    ],
    PagesList: [],
    pageID: null,
    total: 0,
    dialog: false,
    dataItem: {
      id: null,
      is_active: 1,
      phone: null,
      group_id: null,
      name: null,
      name_company: null,
      address: null,
      group: null,
    },
    group: [],
    status: 0,
    countDay: 0,
    purchases: null,
  }),
  components: { Purchases, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),

    exportToServer(item, server) {
      this.loading = true;
      axios
        .post("admin/distributors/orders/export", {
          order_id: item.id,
          resources: server,
        })
        .then((response) => {
          this.$toast.success({
            title: "Export Товаров",
            message: "Товары успешно отправлены",
          });
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setOrders(val) {
      if (val) {
        this.getItems();
      }
    },
    getItems(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/distributors/orders/list", {
          params: {
            page: this.page,
            per_page: 5,
            search: this.search,
            start_at: this.start_at,
            end_at: this.end_at,
            status: this.status,
          },
        })
        .then((response) => {
          this.PagesList = response.data.data;
          this.last_page = response.data.last_page;
          this.total = response.data.total;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },
    closeDialog() {
      this.getItems();
      this.purchases = null;
    },

    notify() {
      this.loading = true;
      axios
        .put("admin/distributors/notify", this.dataItem)
        .then((response) => {
          this.$toast.success({
            title: this.vendor_code,
            message: "Пароль успешно отправлен на номер",
          });
          this.dataItem = response.data;
          setTimeout(() => {
            // this.getItems();
          }, 300);
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setZero(val) {
      if (val <= 9) {
        val = "0" + val;
      }
      return val;
    },

    setDay() {
      this.page = 1;
      setTimeout(() => {
        let now = new Date(Date.now());
        let today = this.setZero(now.getDate());
        let month = this.setZero(now.getMonth() + 1);
        let year = now.getFullYear();
        if (!this.countDay) {
          this.countDay = 0;
        }
        let endDate = Date.now() - this.countDay * 24 * 3600 * 1000;
        let startNow = new Date(endDate);
        let todayNow = this.setZero(startNow.getDate());
        let monthNow = this.setZero(startNow.getMonth() + 1);
        let yearNow = startNow.getFullYear();
        this.start_at = yearNow + "-" + monthNow + "-" + todayNow;
        this.end_at = year + "-" + month + "-" + today;
      }, 20);
      setTimeout(() => {
        this.getItems();
      }, 300);
    },
    setResource() {
      setTimeout(() => {
        this.page = 1;
        this.getItems();
      }, 400);
    },
    clearRange() {
      this.page = 1;
      this.search = "";
      this.status = 0;
      this.start_at = this.end_at = null;
      this.countDay = 0;
      setTimeout(() => {
        this.getItems();
      }, 300);
    },
    setStatus(data) {
      this.loading = true;
      axios
        .put("admin/distributors/orders/status", {
          id: data.id,
          status: data.status,
        })
        .then((response) => {
          this.$toast.success({
            title: this.vendor_code,
            message: "Статус заказа изменен",
          });
          this.status = data.status;
          setTimeout(() => {
            this.getItems();
          }, 20);
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    serverSend(order_id) {
      this.loading = true;
      axios
        .post("admin/distributors/orders/send", {
          order_id: order_id,
        })
        .then((response) => {
          this.$toast.success({
            title: "Отправка в 1с",
            message: "Заказы успешно отправлены",
          });
          setTimeout(() => {
            this.getItems();
          }, 100);
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getItems(true);
      }, 1500);
    },
    page() {
      setTimeout(() => {
        this.getItems();
      }, 300);
    },
  },
  mounted() {
    this.getItems();
  },
  computed: {
    dialogShow: {
      get() {
        return this.purchases;
      },
    },
  },
};
</script>

<style>
.netrogay {
  display: none;
}
</style>